/**
 * PATH: packages/ui/src/kanban/components/KanbanCardFace.tsx
 * FILE_ID: UI-KANBAN-CARD-FACE-001
 * PURPOSE: Render the card-face blocks in the operator's saved order,
 *          skipping hidden ones.
 * WHY: Extracted from KanbanCard so the tile stays under the 500-line
 *      ceiling and settings can drive layout without forking the card.
 * RELATED: ./board-view/cardFacePrefs.ts; ./KanbanCard.tsx.
 */
import { Fragment, type ReactNode } from 'react'

import {
  orderedVisibleCardFaceBlocks,
  type CardFaceBlockId,
  type KanbanCardFacePrefs,
} from './board-view/cardFacePrefs'

export interface KanbanCardFaceProps {
  prefs: KanbanCardFacePrefs
  slots: Partial<Record<CardFaceBlockId, ReactNode>>
}

export function KanbanCardFace({ prefs, slots }: KanbanCardFaceProps) {
  return (
    <div data-card-face="">
      {orderedVisibleCardFaceBlocks(prefs).map((id) => {
        const node = slots[id]
        if (node == null) return null
        return <Fragment key={id}>{node}</Fragment>
      })}
    </div>
  )
}
